import './style/index.js';

import _Loading from './loading';

export const ChatLoading = _Loading;
export default ChatLoading;

export * from './type';
